/**
 * Emails Service for Portal
 *
 * Fetches the logged-in investor's own email history (the business emails we've
 * sent them) from the portal API. Scoping is enforced server-side by the
 * session's selected investor; this client only ever hits the unscoped paths.
 */

import { investorPortalApiClient } from '../../shared/utils/api-client';
import type {
  InvestorEmailLogDetail,
  InvestorEmailLogList,
  InvestorEmailLogParams,
} from '@/types/investorEmail';

export class EmailsService {
  /** One page of the emails we've sent the investor, newest first. */
  static async getAllEmails(
    params: InvestorEmailLogParams = {}
  ): Promise<InvestorEmailLogList> {
    return investorPortalApiClient.get<InvestorEmailLogList>('/portal/emails', {
      params,
    });
  }

  /** One email including its rendered body. */
  static async getEmailDetail(
    emailId: string
  ): Promise<InvestorEmailLogDetail> {
    return investorPortalApiClient.get<InvestorEmailLogDetail>(
      `/portal/emails/${emailId}`
    );
  }
}
